<div class="cmp-overlay" *ngIf="visible" (click)="onClose()">
  <div class="cmp-popup" [class.cmp-popup--bulk]="isBulk" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="cmp-header">
      <div class="cmp-header-title">
        <div class="cmp-header-icon">
          <i class="fas fa-box-archive"></i>
        </div>
        <div>
          <h3>{{ isBulk || isEmptySelection ? 'Chiusura Manuale Resi' : 'Chiusura Manuale Reso' }}</h3>
          <p *ngIf="isEmptySelection">Nessun reso selezionato</p>
          <p *ngIf="!isEmptySelection && !isBulk">Scegli il magazzino, imposta la data di consegna e registra la chiusura</p>
          <p *ngIf="isBulk">Chiude i {{ pallets.length }} resi selezionati con lo stesso magazzino e la stessa data di consegna</p>
        </div>
      </div>
      <button type="button" class="cmp-close-btn" (click)="onClose()" [disabled]="isSubmitting" title="Chiudi">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Body -->
    <div class="cmp-body">

      <!-- Errore di validazione o del backend -->
      <div class="cmp-error" *ngIf="errorMessage">
        <i class="fas fa-exclamation-triangle"></i>
        <span>{{ errorMessage }}</span>
      </div>

      <!-- ===== ESITO DELLA CHIUSURA MULTIPLA: prende il posto del form ===== -->
      <div class="cmp-result" *ngIf="result">
        <div class="cmp-result-head" [class.has-errors]="!isFullyApplied">
          <i class="fas" [ngClass]="isFullyApplied ? 'fa-circle-check' : 'fa-triangle-exclamation'"></i>
          <div>
            <strong>{{ resultTitle }}</strong>
            <span>
              {{ result.appliedRows }} di {{ result.receivedItems }} resi inviati sono stati chiusi
              con la data indicata.
            </span>
          </div>
        </div>

        <div class="cmp-result-counts">
          <div class="cmp-result-count">
            <span class="cmp-result-count-value">{{ result.receivedItems }}</span>
            <span class="cmp-result-count-label">Inviati</span>
          </div>
          <div class="cmp-result-count is-applied">
            <span class="cmp-result-count-value">{{ result.appliedRows }}</span>
            <span class="cmp-result-count-label">Resi chiusi</span>
          </div>
          <div class="cmp-result-count" [class.is-warning]="hasSkippedRows">
            <span class="cmp-result-count-value">{{ result.skippedRows }}</span>
            <span class="cmp-result-count-label">Saltati</span>
          </div>
          <div class="cmp-result-count" [class.is-error]="hasErrorRows">
            <span class="cmp-result-count-value">{{ result.errorRows }}</span>
            <span class="cmp-result-count-label">Scartati</span>
          </div>
        </div>

        <!-- Resi non trovati o già al quinto stato -->
        <div class="cmp-result-list" *ngIf="hasSkippedRows">
          <div class="cmp-result-list-title">Resi saltati</div>
          <ul>
            <li *ngFor="let item of result.skipped">
              <span class="cmp-result-list-row" *ngIf="rowLabel(item)">{{ rowLabel(item) }}</span>
              <span class="cmp-result-list-reason">{{ rowReason(item) }}</span>
            </li>
          </ul>
        </div>

        <!-- Elementi senza i tre codici -->
        <div class="cmp-result-list is-error" *ngIf="hasErrorRows">
          <div class="cmp-result-list-title">Elementi scartati</div>
          <ul>
            <li *ngFor="let item of result.errors">
              <span class="cmp-result-list-row" *ngIf="rowLabel(item)">{{ rowLabel(item) }}</span>
              <span class="cmp-result-list-reason">{{ rowReason(item) }}</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- ===== NESSUN RESO SELEZIONATO: avviso e guida alla chiusura massiva ===== -->
      <div class="cmp-guide" *ngIf="isEmptySelection">
        <div class="cmp-guide-warning">
          <i class="fas fa-triangle-exclamation"></i>
          <div>
            <strong>Nessun reso selezionato</strong>
            <span>Per chiudere più resi con la stessa data di consegna, seleziona prima le righe in tabella.</span>
          </div>
        </div>

        <div class="cmp-guide-title">Come effettuare la chiusura massiva</div>
        <ol class="cmp-guide-steps">
          <li>
            <span class="cmp-guide-step-num">1</span>
            <div>
              <strong>Seleziona i resi</strong>
              <span>Spunta la checkbox nella colonna <em>Seleziona</em> delle righe da chiudere.
                La checkbox compare solo sui resi non ancora consegnati.</span>
            </div>
          </li>
          <li>
            <span class="cmp-guide-step-num">2</span>
            <div>
              <strong>Seleziona tutta la pagina in un colpo</strong>
              <span>La checkbox nell'intestazione della colonna seleziona o deseleziona tutti i resi
                chiudibili della pagina corrente. La selezione resta anche cambiando pagina.</span>
            </div>
          </li>
          <li>
            <span class="cmp-guide-step-num">3</span>
            <div>
              <strong>Apri la chiusura multipla</strong>
              <span>Premi il bottone arancione <i class="fas fa-calendar-check mx-1"></i> nell'intestazione
                della sezione: il numero sul badge indica i resi selezionati.</span>
            </div>
          </li>
          <li>
            <span class="cmp-guide-step-num">4</span>
            <div>
              <strong>Scegli magazzino e data, poi conferma</strong>
              <span>Scegli il magazzino di chiusura e l'unica data di consegna da applicare a tutti i
                resi elencati e premi <em>Chiudi resi</em>. I resi già consegnati vengono saltati e
                l'esito viene mostrato nel popup.</span>
            </div>
          </li>
        </ol>

        <p class="cmp-guide-hint">
          <i class="fas fa-circle-info me-1"></i>
          Per chiudere un solo reso puoi anche usare il bottone <em>Chiudi</em> nella colonna
          <em>Data Consegna</em> della riga.
        </p>
      </div>

      <!-- ===== FORM DI CHIUSURA ===== -->
      <ng-container *ngIf="!result && !isEmptySelection">

        <!-- Codici del bancale: individuano il reso lato backend -->
        <div class="cmp-section-title">
          <i class="fas fa-pallet me-2"></i>
          {{ isBulk ? 'Resi da chiudere (' + pallets.length + ')' : 'Reso da chiudere' }}
        </div>

        <!-- Reso singolo: i tre codici in colonna -->
        <div class="cmp-codes" *ngIf="!isBulk">
          <div class="cmp-code">
            <span class="cmp-code-label"><i class="fas fa-box-open"></i> Codice Reso</span>
            <span class="cmp-code-value">{{ pallets[0].palletCode || '-' }}</span>
          </div>
          <div class="cmp-code">
            <span class="cmp-code-label"><i class="fas fa-barcode"></i> Codice Bolla</span>
            <span class="cmp-code-value">{{ pallets[0].palletWaybillCode || '-' }}</span>
          </div>
          <div class="cmp-code">
            <span class="cmp-code-label"><i class="fas fa-truck"></i> Codice Spedizione</span>
            <span class="cmp-code-value">{{ pallets[0].palletShipmentCode || '-' }}</span>
          </div>
        </div>

        <!-- Più resi: elenco scorrevole con i tre codici per riga -->
        <div class="cmp-list-wrapper" *ngIf="isBulk">
          <table class="cmp-list">
            <thead>
              <tr>
                <th class="cmp-list-index">#</th>
                <th><i class="fas fa-box-open me-1"></i>Codice Reso</th>
                <th><i class="fas fa-barcode me-1"></i>Codice Bolla</th>
                <th><i class="fas fa-truck me-1"></i>Codice Spedizione</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of pallets; let i = index; trackBy: trackByPalletCode">
                <td class="cmp-list-index">{{ i + 1 }}</td>
                <td class="cmp-list-code">{{ p.palletCode || '-' }}</td>
                <td class="cmp-list-code">{{ p.palletWaybillCode || '-' }}</td>
                <td class="cmp-list-code">{{ p.palletShipmentCode || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Magazzino di chiusura: quelli autorizzati all'utente più la destinazione dei resi -->
        <div class="cmp-section-title">
          <i class="fas fa-warehouse me-2"></i>Magazzino di chiusura
        </div>
        <div class="cmp-warehouse">
          <app-searchable-select
                  [(ngModel)]="warehouseCode"
                  [options]="warehouseOptions"
                  [disabled]="isSubmitting || isLoadingWarehouses || warehouseOptions.length === 0"
                  [loading]="isLoadingWarehouses"
                  allOptionLabel=""
                  placeholder="Seleziona il magazzino..."
                  icon="fas fa-warehouse"
                  searchPlaceholder="Cerca magazzino..."
                  (valueChange)="onWarehouseChange()">
          </app-searchable-select>
        </div>
        <p class="cmp-date-hint" *ngIf="isLoadingWarehouses">
          <i class="fas fa-spinner fa-spin me-1"></i>Caricamento dei magazzini disponibili...
        </p>
        <p class="cmp-date-hint cmp-warehouse-empty" *ngIf="!isLoadingWarehouses && warehouseOptions.length === 0">
          <i class="fas fa-triangle-exclamation me-1"></i>
          Nessun magazzino disponibile per la chiusura: verifica le tue autorizzazioni.
        </p>
        <p class="cmp-date-hint" *ngIf="!isLoadingWarehouses && warehouseOptions.length > 0">
          Puoi scegliere tra i magazzini a cui sei autorizzato e la destinazione
          {{ isBulk ? 'dei resi' : 'del reso' }}.
        </p>

        <!-- Data di consegna -->
        <div class="cmp-section-title">
          <i class="fas fa-clock me-2"></i>Data di consegna
        </div>
        <div class="cmp-date">
          <div class="cmp-date-input-wrapper" (click)="openPicker()">
            <i class="fas fa-calendar-alt cmp-date-icon"></i>
            <input #deliveryDateInput
                   type="text"
                   class="form-control cmp-date-input"
                   placeholder="gg/mm/aaaa hh:mm"
                   [disabled]="isSubmitting"
                   readonly>
            <button type="button" class="cmp-date-clear" *ngIf="deliveryDate"
                    (click)="clearDate(); $event.stopPropagation()"
                    [disabled]="isSubmitting" title="Svuota data">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <button type="button" class="btn btn-outline-secondary btn-sm cmp-now-btn"
                  (click)="setNow()" [disabled]="isSubmitting" title="Imposta a adesso">
            <i class="fas fa-stopwatch me-1"></i> Adesso
          </button>
        </div>
        <p class="cmp-date-hint" *ngIf="!isBulk">
          La data viene registrata come data di consegna effettiva e il reso passa allo stato
          <strong>5 - Consegnato</strong> sul magazzino scelto.
        </p>
        <p class="cmp-date-hint" *ngIf="isBulk">
          La stessa data viene registrata come data di consegna effettiva di tutti i resi elencati,
          che passano allo stato <strong>5 - Consegnato</strong> sul magazzino scelto. I resi già
          consegnati vengono saltati.
        </p>
      </ng-container>
    </div>

    <!-- Footer -->
    <div class="cmp-footer">
      <!-- Senza selezione c'è solo la guida: un unico bottone di chiusura, arancione -->
      <button type="button" class="btn btn-sm cmp-submit-btn"
              *ngIf="isEmptySelection"
              (click)="onClose()">
        <i class="fas fa-check me-1"></i> Ho capito
      </button>
      <button type="button" class="btn btn-outline-secondary btn-sm"
              *ngIf="!isEmptySelection"
              (click)="onClose()" [disabled]="isSubmitting">
        {{ result ? 'Chiudi' : 'Annulla' }}
      </button>
      <button type="button" class="btn btn-sm cmp-submit-btn"
              *ngIf="!result && !isEmptySelection"
              (click)="onSubmit()" [disabled]="!canSubmit">
        <i class="fas me-1" [ngClass]="isSubmitting ? 'fa-spinner fa-spin' : 'fa-check'"></i>
        <ng-container *ngIf="isSubmitting">Chiusura in corso...</ng-container>
        <ng-container *ngIf="!isSubmitting">{{ isBulk ? 'Chiudi ' + pallets.length + ' resi' : 'Chiudi reso' }}</ng-container>
      </button>
    </div>
  </div>
</div>
